import request from '@/utils/request';
export function getLanguagePack(params) {
  return request({
    url: '/common/translate/get_language_pack/',
    method: 'post',
    data: params
  });
}